import { FeedTypes } from "./FeedTypes";

export const FeedTypeDescription = new Map<number, string>([
    [FeedTypes.PermissionFeed, "Permission Feed"],
    [FeedTypes.HierarchyFeed, "Hierarchy Feed"],
    [FeedTypes.LookupListFeed, "Lookup/List Feed"],
    [FeedTypes.OshaEstablishmentFeed, "OSHA Establishment Feed"],
    [FeedTypes.HierarchyOSHAEstablishmentFeed, "Hierarchy OSHA Establishment Information"],
    [FeedTypes.ModuleRecordFeed, "Module Record Feed"]
]);